module.exports = __webpack_public_path__ + "static/media/logo-max3d.60a83835.png";